import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDashboardStore } from '../stores/dashboardStore';
import './Internships.css';

const Internships: React.FC = () => {
    const { config } = useDashboardStore();
    const { internshipId } = useParams<{ internshipId: string }>();

    // 页面加载时滚动到顶部
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [internshipId]);

    // 如果指定了实习ID，显示单个实习详情
    if (internshipId) {
        const internship = config.internships.find(i => i.id === internshipId);
        if (!internship) {
            return (
                <div className="internships-page">
                    <div className="container">
                        <div className="not-found">
                            <h1>实习经历未找到</h1>
                            <p>抱歉，您访问的实习经历不存在。</p>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="internship-detail-page">
                <div className="container">
                    <div className="internship-header">
                        <div className="company-header">
                            <div className="company-logo">
                                <img src={internship.logo} alt={internship.company} />
                            </div>
                            <div className="company-info">
                                <h1>{internship.company}</h1>
                                <h2>{internship.position}</h2>
                                <div className="meta-info">
                                    <span className="period">{internship.period}</span>
                                    <span className="location">{internship.location}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="internship-content">
                        <div className="content-section">
                            <h3>实习概述</h3>
                            <p>{internship.description}</p>
                        </div>

                        <div className="content-section">
                            <h3>工作内容</h3>
                            <div className="work-content">
                                {Object.entries(internship.workContent).map(([achievement, responsibilities], index) => (
                                    <div key={index} className="work-item">
                                        <div className="achievement-title">
                                            <span className="star">★</span>
                                            {achievement}
                                        </div>
                                        <ul className="responsibilities-list">
                                            {responsibilities.map((responsibility, respIndex) => (
                                                <li key={respIndex}>{responsibility}</li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="content-section">
                            <h3>核心技能</h3>
                            <div className="skills-container">
                                {internship.skills.map((skill, index) => (
                                    <span key={index} className="skill-tag">{skill}</span>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    // 显示所有实习列表
    return (
        <div className="internships-page">
            <div className="container">
                <div className="page-header">
                    <h1>实习经历</h1>
                    <p>在知名公司的实习经历让我深入理解了产品经理的工作内容和核心技能。</p>
                </div>

                <div className="internships-grid">
                    {config.internships.map((internship) => (
                        <div key={internship.id} className="internship-card">
                            <div className="card-header">
                                <div className="company-logo">
                                    <img src={internship.logo} alt={internship.company} />
                                </div>
                                <div className="company-info">
                                    <h3>{internship.company}</h3>
                                    <p className="position">{internship.position}</p>
                                    <div className="meta-info">
                                        <span className="period">{internship.period}</span>
                                        <span className="location">{internship.location}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="card-content">
                                <p className="description">{internship.description}</p>

                                <div className="section">
                                    <h4>工作内容</h4>
                                    <div className="work-content-preview">
                                        {Object.entries(internship.workContent).slice(0, 2).map(([achievement, responsibilities], index) => (
                                            <div key={index} className="work-item-preview">
                                                <div className="achievement-title">
                                                    <span className="star">★</span>
                                                    {achievement}
                                                </div>
                                                <ul className="responsibilities">
                                                    {responsibilities.slice(0, 2).map((responsibility, respIndex) => (
                                                        <li key={respIndex}>{responsibility}</li>
                                                    ))}
                                                    {responsibilities.length > 2 && <li>...</li>}
                                                </ul>
                                            </div>
                                        ))}
                                        {Object.keys(internship.workContent).length > 2 && (
                                            <div className="more-indicator">...</div>
                                        )}
                                    </div>
                                </div>

                                <div className="section">
                                    <h4>核心技能</h4>
                                    <div className="skills">
                                        {internship.skills.map((skill, index) => (
                                            <span key={index} className="skill-tag">
                                                {skill}
                                            </span>
                                        ))}
                                    </div>
                                </div>

                            </div>

                            <div className="card-footer">
                                <Link
                                    to={`/internships/${internship.id}`}
                                    className="btn btn-primary"
                                >
                                    查看详情
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Internships;



